export default "__VITE_ASSET__00vIsY_R__"